<template>
  <div class="card">
    <div class="card-header border-0 p-2 bg-success">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Cổng</h3>
        </div>
      </div>
    </div>
    <form>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <th>Đơn Vị</th>
          <th>Họ Tên</th>
          <th>Định danh</th>
          <th class="mb-0">T.Khách</th>
          <th class="mb-0">BS.Xe</th>
          <th class="mb-0">T.Chức Năng</th>
          <th>Vào</th>
          <th>Ra</th>
          <th></th>
        </thead>
        
        <tbody>
            <tr v-for="(job, inx) in jobs" :key="inx">
              <th class="py-1">
                {{ job.orgName}}
              </th>     
              <td  class="py-1" >
                {{job.tenant}}
              </td>
              <td class="py-1" >
                {{job.tenantNational}}
              </td>
              <td class="py-1" width="5%" >
                {{job.l1Id}}
              </td>
              <td class="py-1" width="12%">
                {{job.vehicleId}}
              </td>
              <td class="py-1" width="5%" >
                <base-input input-classes="form-control" class="mb-0">
                  <select v-model.lazy="job.l2Id" >                          
                    <option v-for="the in thechucnang" :value=the :key="the">{{ the }}</option>
                  </select>
                </base-input>
                <!--
                <base-input placeholder="T.Chức Năng"  v-model.lazy="job.l2Id"  input-classes="form-control-sm" class="mb-0"></base-input>
                -->
              </td>
              <td  class="py-1" >
                {{ formattime(job.in1Date)}}
              </td>
              <td class="py-1">
                {{formattime(job.out2Date)}}
              </td>  
              <td class="text-right py-1" >
                <base-button type="primary" class="btn-sm" v-if="permitl2" @click="checkinlayer2(job)">Vào</base-button>
              </td>
              <td class="text-right py-1" >
                <base-button type="primary" class="btn-sm" v-if="permitl1" @click="checkoutlayer1(job)">Ra</base-button>
              </td>
              
            </tr>
        </tbody>
        
      </table>
    </div>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'layer_1',
    props:{
      title: {
        type: String
      },
      layer: {
        type: [String, Number]
      },
      proctors: {
        type: Array
      },
      location: {
        type: String
      },
      jobs: {
        type: Array
      },
      thechucnang: {
        type: Array
      }
    },
    data() {
      return {
        }
    },
    methods: {

      checkinlayer2(job) {
        let data = {
          jobId: job._id,
          l2Id: job.l2Id,
          l2Proctor: this.$store.state.user.username
        }
        job.status = 5
        job.l2Proctor = this.$store.state.user.username
        job.in2Date = this.$moment()
        if(job.l2Id) {
          let card= {layer: 1,id:job.l2Id}
          this.$emit('deleteThe',card)
        }
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/in/layer2', data)
        
        
        
      },
      checkoutlayer1(job) {
        let data = {
          jobId: job._id
        }
        job.status = 9
        job.out1Date = this.$moment()
        job.openning = false
        if(job.l1Id) {
          let card = {layer:0, id:job.l1Id }
          this.$emit('addThe',card)
        }
        if(job.l2Id) {
          let card = {layer:1, id:job.l2Id }
          this.$emit('addThe',card)
        }
        if(job.l3Id){
          let card = {layer:2, id:job.l3Id }
          this.$emit('addThe',card)
        }        
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/out/layer1', data)
        
        
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
    },
    computed: {
       permitl1() {
          return this.$store.getters.permit_l1;
        },
        permitl2() {
          return this.$store.getters.permit_l2;
        },
        permitl3() {
          return this.$store.getters.permit_l3;
        }
    },
    mounted() {

    },
    beforeDestroy() {

    },
  }
</script>
<style>
</style>
